// src/components/Filters/IngredientsFilter.js
import React, { useState, useMemo } from 'react';
import { ingredientCategories } from '../../data/filterOptions';
import './FilterStyles.css';
import './IngredientsFilter.css'; // Specific styles for this component

const IngredientItem = ({ ingredient, isSelected, onToggle }) => (
  <label className="filter-option-label ingredient-item">
    <input
      type="checkbox"
      checked={isSelected}
      onChange={() => onToggle(ingredient)}
    />
    {ingredient}
  </label>
);

const IngredientCategory = ({ category, ingredients, selectedIngredients, onToggleIngredient }) => {
  const [isOpen, setIsOpen] = useState(false); // Collapsible state

  return (
    <div className="ingredient-category">
      <button
        type="button"
        className="category-toggle-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {category}
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}></span>
      </button>
      {isOpen && (
        <div className="filter-options-grid checkbox-grid-ingredients">
          {ingredients.map(ingredient => (
            <IngredientItem
              key={ingredient}
              ingredient={ingredient}
              isSelected={selectedIngredients.includes(ingredient)}
              onToggle={onToggleIngredient}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const IngredientsFilter = ({ selectedIngredients, onChange }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleToggleIngredient = (ingredient) => {
    const newSelectedIngredients = selectedIngredients.includes(ingredient)
      ? selectedIngredients.filter(i => i !== ingredient)
      : [...selectedIngredients, ingredient];
    onChange(newSelectedIngredients);
  };

  // Memoize filtered categories to avoid re-computation on every render
  const filteredCategories = useMemo(() => {
    if (!searchTerm.trim()) {
      return ingredientCategories;
    }
    const lowerSearchTerm = searchTerm.toLowerCase();
    return ingredientCategories
      .map(category => ({
        ...category,
        ingredients: category.ingredients.filter(ingredient =>
          ingredient.toLowerCase().includes(lowerSearchTerm)
        ),
      }))
      .filter(category => category.ingredients.length > 0);
  }, [searchTerm]);


  return (
    <div className="filter-section">
      <h3>Ingredients</h3>
      <input
        type="text"
        placeholder="Search ingredients..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="ingredient-search-input"
      />
      <div className="ingredients-list">
        {filteredCategories.length > 0 ? (
          filteredCategories.map(({ category, ingredients }) => (
            <IngredientCategory
              key={category}
              category={category}
              ingredients={ingredients}
              selectedIngredients={selectedIngredients}
              onToggleIngredient={handleToggleIngredient}
            />
          ))
        ) : (
          <p>No ingredients found matching "{searchTerm}".</p>
        )}
      </div>
    </div>
  );
};

export default IngredientsFilter;
